import { Api } from 'utils/json-api-client'
import { Sessions } from './sessions'
import { V2 } from './v2'

const api = new Api({
  base: 'http://47.241.97.23:8010/proxy',
})

export const sessions = new Sessions(api)
export const v2 = new V2(api)
